import { render, staticRenderFns } from "./user-group-from-user-editor.vue?vue&type=template&id=af12227a&scoped=true&"
import script from "./user-group-from-user-editor.vue?vue&type=script&lang=ts&"
export * from "./user-group-from-user-editor.vue?vue&type=script&lang=ts&"
import style0 from "./user-group-from-user-editor.vue?vue&type=style&index=0&id=af12227a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af12227a",
  null
  
)

export default component.exports